import React, { ReactElement } from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';
import { SignupStepFooterActionsPhone } from 'src/components/selfService/features/Signup/components/SignupStepFooterActions/variants/SignupStepFooterActionsPhone';
import { SignupStepFooterActionsThreeButtons } from 'src/components/selfService/features/Signup/components/SignupStepFooterActions/variants/SignupStepFooterActionsThreeButtons';
import { SignupStepFooterActionsTwoButtons } from 'src/components/selfService/features/Signup/components/SignupStepFooterActions/variants/SignupStepFooterActionsTwoButtons';

export interface SignupStepFooterActionsProps {
  isUpdating: boolean;
  back: ReactElement;
  skip?: ReactElement;
  next: ReactElement;
}

export function SignupStepFooterActions({
  isUpdating,
  back,
  skip,
  next,
}: SignupStepFooterActionsProps): JSX.Element {
  const { isPhone } = useScreenSizes();

  const effectiveBack = isUpdating ? undefined : back;

  if (isPhone) {
    return (
      <SignupStepFooterActionsPhone
        back={effectiveBack}
        skip={skip}
        next={next}
      />
    );
  }

  if (skip) {
    return (
      <SignupStepFooterActionsThreeButtons
        back={effectiveBack}
        skip={skip}
        next={next}
      />
    );
  }

  return <SignupStepFooterActionsTwoButtons back={effectiveBack} next={next} />;
}
